import React, { useState, useEffect } from "react";
import "../InvestmentFrequency/InvestmentFrequency.modules.css";
import beginners from "../../../../../assets/images/Sharjah/Onboarding/1.png";
import expert from "../../../../../assets/images/Sharjah/Onboarding/2.png";
import proficient from "../../../../../assets/images/Sharjah/Onboarding/3.png";
import i18next from "i18next";
import * as Helpers from "../../../../../global/Helpers";
import { useTranslation } from "react-i18next";

function FinancialInstruments(props) {
  const { t } = useTranslation();

  const [selected, setSelected] = useState("");

  const handleClick = (value) => {
    setSelected(value);
  };

  useEffect(() => {
    ;
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    ;
    if (props.RequestItemsList !== undefined && props.RequestItemsList !== null) {
      if (props.RequestItemsList.length >= 4) {
        if (selected === null || selected === "") {
          Helpers.errorNotify(t("Please fill Financial Instruments Data"), i18next.language);
          props.setRequestItemsList([]);
          props.setIsCallAPI(false);
          return false;
        }
      } else {
        props.setRequestItemsList([]);
        props.setIsCallAPI(false);
        return false;
      }
    }

    return true;
  }

  const saveKycDataFun = () => {
    ;
    if (!validateSubmit()) return;


            var result = Helpers.getScreenIdByGroupAndName("Product Selection");

    
    var arr = props.RequestItemsList;
    arr.push({ ID: "239", Value: selected });
    arr.push({ ID: "258", Value: "1" });
    arr.push({ID: "288", Value: result?.GROUP_ID || "" });
    arr.push({ID: "287", Value: result?.SCREEN_ID || "" });
    props.setRequestItemsList(arr);
    props.setIsCallAPIOnce(true);
  };

  return (
    <div className="InvestmentFrequency-container" style={{ marginTop: "15px" }}>
      <h2>{t("AttitudFinancialInstruments")}</h2>

      <div className="button-group">
        <button
          className={`frequency-button ${selected === "B" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("B");
          }}>
          <img src={beginners} style={{ width: "100%", height: "90%" }} />
          {t("beginners")}
        </button>

        <button
          className={`frequency-button ${selected === "P" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("P");
          }}>
          <img src={proficient} style={{ width: "100%", height: "90%" }} />
          {t("proficient")}
        </button>

        <button
          className={`frequency-button ${selected === "E" ? "active" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            handleClick("E");
          }}>
          <img src={expert} style={{ width: "100%", height: "90%" }} />
          {t("expert")}
        </button>
      </div>
    </div>
  );
}

export default FinancialInstruments;
